import { createContext } from "react"

/** Shows only `key` among `allKeys`; called again on the lone visible series, shows all. */
export const SeriesIsolationContext = createContext<
  ((key: string, allKeys: readonly string[]) => void) | null
>(null)
